import esLocale from 'date-fns/locale/es';
import jaLocale from 'date-fns/locale/ja';

export const DATE_LOCALES = {
    es: esLocale,
    ja: jaLocale
};
export const DEFAULTS = {
    language: 'en',
    locale: 'en-US'
};
export const languageToLocale = new Map([
    ['en', 'en-US'],
    ['es', 'es-US'],
    ['ja', 'ja-JP']
]);

const langToFullLangPath = new Map([
    ['en', ''],
    ['es', 'es'],
    ['ja', 'ja']
]);

const langToSafeLangPath = new Map([
    ['en', ''],
    ['es', 'es'],
    ['ja', '']
]);

export const getLanguagePath = (language, trailingChar = '/') => {
    const langPath = langToFullLangPath.get(language);
    return langPath ? langPath + trailingChar : '';
};

export const getSafeLanguagePath = (language, trailingChar = '/') => {
    const langPath = langToSafeLangPath.get(language);
    return langPath ? langPath + trailingChar : '';
};

export const getFormattedLangOptions = (language, locale) => {
    let updatedLocale; let updatedLanguage;
    if (!locale && language) {
        updatedLocale = (languageToLocale.get(language));
        updatedLanguage = language;
    } else if (locale && !language) {
        const [lang, localeCode] = (locale).split(/-|_/);
        updatedLanguage = lang;
        updatedLocale = languageToLocale.get(updatedLanguage);
    } else if (!locale && !language) {
        updatedLocale = DEFAULTS.locale;
        updatedLanguage = DEFAULTS.language;
    } else {
        updatedLanguage = language;
        updatedLocale = locale;
    }
    return { updatedLanguage, updatedLocale };
};

export const DATE_FORMATS = {
    SHORT: 'short',
    STANDARD: 'standard',
    LONG: 'long',
    DAY: 'day'
};

const langToDateLocale = new Map([
    ['en', undefined],
    ['es', { locale: DATE_LOCALES.es }],
    ['ja', { locale: DATE_LOCALES.ja }]
]);

const langToLongDateFormat = new Map([
    ['en', 'MMMM d, yyyy'],
    ['es', "d 'de' MMM yyyy"],
    ['ja', 'yoModo']
]);

const langToMediumDateFormat = new Map([
    ['en', 'MMM d, yyyy'],
    ['es', "dd 'de' MMM, yyyy"],
    ['ja', 'yoModo']
]);

const langToShortDateFormat = new Map([
    ['en', 'E M/d'],
    ['es', 'E d/M'],
    ['ja', 'E M/d']
]);

const langToDayDateFormat = new Map([
    ['en', 'EEEE, MMMM do'],
    ['es', "E, d 'de' MMMM"],
    ['ja', 'ModoEEEE']
]);

const formatToMap = {
    [DATE_FORMATS.SHORT]: langToShortDateFormat,
    [DATE_FORMATS.STANDARD]: langToMediumDateFormat,
    [DATE_FORMATS.LONG]: langToLongDateFormat,
    [DATE_FORMATS.DAY]: langToDayDateFormat
};

export const getDateFormatOptions = (language) => {
    const dateLocaleObj = langToDateLocale.get(language);
    return dateLocaleObj || undefined;
};

export const getDateFormat = (language, format) => {
    const map = formatToMap?.[format] || langToMediumDateFormat;
    return map.get(language) || 'MMMM d, yyyy';
};
